import HomeNav from "./HomeNav/HomeNav";
import './blc_main.css';
import { useHomePagaData } from "../Blc_Business/BlcHomeLandingPage/HomeWindowTwo";
import Spinner from "react-bootstrap/Spinner";
import { useLocationPageData } from "../Blc_Business/FristSixBLC/LocationsPageDataHandling";
import { useBlcFacilityPageData } from "../Blc_Business/BlcFacilityPage/BlcFacilityPage";
import { useBlcGalleryPageData } from "../Blc_Business/BlcGalleryPage/BlcGallerypage";
import { useBlcReservationPageData } from "../Blc_Business/BlcReservationPage/BlcReservationPage";
import { useBlcFaqPageData } from "../Blc_Business/BlcFaqPageData/BlcFaqPageData";
import { useContactPageData } from "../Blc_Business/BlcContactPageData/BlcContactPageData";
import BlcMessenger from "../Blc_Common/BlcMessenger";
import HomeNavCopy from "./HomeNav/HomeNav_copy";



//HomeNav calls on App.js

const Home = () => {

  const blcData = useHomePagaData();
  const myData = useLocationPageData();
  const facData = useBlcFacilityPageData();
  const galleryData = useBlcGalleryPageData();
  const reservationData = useBlcReservationPageData();
  const faqData = useBlcFaqPageData();
  const contactData = useContactPageData();

  // if(contactData[0] !== undefined ){
  //   console.log("ranjit");
  //   console.log(contactData[0].data.data.attributes);
  // }




  function waitFordata() {
    return (
      <>
        <div className="mySpin">
          <Spinner animation="border" />
        </div>
      </>
    );
  }

  return (
    // Main Nav Start From Here.
    <>
      {blcData[0] && myData[0] && facData[0] !== undefined && galleryData[0] !== undefined && reservationData[0] !== undefined && faqData[0] !== undefined && contactData[0] !== undefined ? <HomeNavCopy blcData={blcData[0]} locationData={myData[0].data.attributes.each_location}
        // {blcData[0] && myData[0] && facData[0] !== undefined && galleryData[0] !== undefined && reservationData[0] !== undefined && faqData[0] !== undefined && contactData[0] !== undefined ? <HomeNav blcData={blcData[0]} locationData={myData[0].data.attributes.each_location}
        facilityData={facData[0].data} blcGalleryData={galleryData[0].data.data.attributes} blcReservationData={reservationData[0].data.data.attributes} faqsData={faqData[0].data.data.attributes} contactPageData={contactData[0].data.data.attributes} /> : waitFordata()}

      <BlcMessenger />
    </>
  );
};

export default Home;
